import * as React from "react";
import { DialogContent, Grid, IconButton } from "@mui/material";
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import { getTenantDoc, deleteTenantDoc } from "state/apis";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useTheme } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";

export default function Document({ open, onClose, editData, editMode }) {
    const theme = useTheme();
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [deleteItem, setDeleteItem] = React.useState(null);

    React.useEffect(() => {
        const fetchData = async () => {
            if (editMode && editData) {
                try {
                    const res = await getTenantDoc(editData.id);
                    setData(res?.data);
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            } else {
                setData([]);
            }
        };

        fetchData();
    }, [editData, editMode]);
    const handleDeleteClick = (row) => {
        setDeleteItem(row?.id);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmation = async () => {
        try {
            await deleteTenantDoc(deleteItem);
            toast.success("Tenant doc deleted successfully.");
            const res = await getTenantDoc(editData.id);
            setData(res?.data);
            setDeleteConfirmationOpen(false);
        } catch (error) {
            console.error("Error deleting tenant doc:", error);
            toast.error("Failed to delete tenant doc. Please try again.");
        }
    };

    const handleDocumentOpen = (url) => {
        window.open(url, "_blank");
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
            <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                Tenant Documents
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}></Grid>
                <TableContainer
                    sx={{ overflowX: "auto", marginBottom: theme.spacing(2), maxHeight: 900 }}
                >
                    <Table
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ backgroundColor: "#fff" }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Sr No
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Doc name
                                </TableCell>
                                <TableCell
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#5a6a85",
                                    }}
                                >
                                    Action
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.length ? (
                                data.map((row, index) => (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell
                                            onClick={() => handleDocumentOpen(row.url)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {row.name}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                color="error"
                                                onClick={() => handleDeleteClick(row)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell
                                        colSpan={3}
                                        sx={{ textAlign: "center", fontWeight: "700", mb: "2px" }}
                                    >
                                        No data found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Dialog
                    open={deleteConfirmationOpen}
                    onClose={() => setDeleteConfirmationOpen(false)}
                >
                    <DialogTitle fontWeight={"bold"}>Are you sure you want to delete?</DialogTitle>
                    <DialogActions>
                        <Button
                            onClick={() => setDeleteConfirmationOpen(false)}
                            sx={{ color: "#5a6a85" }}
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleDeleteConfirmation} color="error" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </DialogContent>
        </Dialog>
    );
}
